<script>
  import { createEventDispatcher } from "svelte";
  import { v4 as uuidv4 } from "uuid";
  import debounce from "lodash/debounce";

  export let onCloseOptionsFunc = () => {},
    options = [],
    isOptionsObj = false,
    nameKey,
    valueKey,
    disabledOptions = [],
    optionsPosition = "bottom",
    displayBoxClass = "",
    displayTextClass = "",
    disabled = false,
    smallOptionsBox = false,
    value = "",
    isMulti = true,
    showColoredOptions = false,
    colorKey = "color",
    addOptionFunction = () => {},
    inputItem = {},
    id = "",
    autoPosition = true,
    longOptions = false,
    placeholder = "";

  const uniqueId = uuidv4(),
    dispatch = createEventDispatcher();

  let showOptions = false,
    operationOptions = [],
    addOptionInputValue = "",
    previousKeyDown = null,
    displayBoxEle,
    optionButtons = [],
    searchInputValue = "";

  const defaultCheckboxClass =
    "checkbox checkbox-secondary checkbox-xs cursor-pointer";

  $: if (options?.length || disabledOptions.length) {
    if (typeof options === "string") options = options.split(",");

    if (isOptionsObj) {
      if (value) {
        operationOptions = options.map((op) => ({
          ...op,
          name: op[nameKey ?? "name"],
          id: op[valueKey ?? "id"],
          selected: isMulti
            ? value.includes(op[valueKey ?? "id"])
            : value == op[valueKey ?? "id"],
        }));
      } else {
        operationOptions = options.map((op) => ({
          ...op,
          name: op[nameKey ?? "name"],
          id: op[valueKey ?? "id"],
          selected: false,
        }));
      }
    } else {
      if (value) {
        operationOptions = options.map((op) => ({
          name: op,
          id: op,
          selected: isMulti ? value.includes(op) : value == op,
        }));
      } else {
        operationOptions = options.map((op) => ({
          name: op,
          id: op,
          selected: false,
        }));
      }
    }
  }

  $: selectedItems = operationOptions.filter((a) => a.selected);

  $: filteredUnselectedOptions = operationOptions.filter(
    (a) =>
      (isMulti ? true : !a.selected) && inSearchResults(a, searchInputValue),
  );

  $: displayPlaceholder = selectedItems.length
    ? isMulti
      ? `${selectedItems.length == 1 ? selectedItems[0].name : `${selectedItems.length} selected`}`
      : ""
    : placeholder;

  const onChangeFunc = debounce(
    () => {
      dispatch("change");
    },
    300,
    { leading: true },
  );

  function toggleOptions() {
    if (!showOptions && !disabled) showOptions = true;
    else hideOptions();
  }

  const hideOptions = () => {
    showOptions = false;
    addOptionInputValue = "";
    onCloseOptionsFunc();
    document.onkeydown = previousKeyDown ?? null;
    dispatch("optionsClosed");
  };

  const selectAll = () => {
    searchInputValue = "";
    filteredUnselectedOptions.forEach((o) => (o.selected = true));
    refreshValues();
  };

  const selectNone = () => {
    operationOptions.forEach((o) => (o.selected = false));
    refreshValues();
  };

  const addOption = async () => {
    addOptionFunction(inputItem, addOptionInputValue);
    // refresh dispaly
    setTimeout(() => {
      inputItem = { ...inputItem };
    }, 1000);
  };

  const onInputBoxFocus = () => {
    if (!disabled) showOptions = true;
  };

  const refreshValues = () => {
    const res = [];
    operationOptions.forEach((op) => {
      if (op.selected) {
        res.push(isOptionsObj ? op.id : op.name);
      }
    });
    value = isMulti ? res : res.toString();

    onChangeFunc();
  };

  $: if (showOptions) {
    if (autoPosition) optionsPosition = calculateOptionsPosition();

    window.addEventListener(
      "click",
      function eventHandler(e) {
        const dropdownSelect = document.getElementById(uniqueId);
        if (
          dropdownSelect &&
          !document.getElementById(uniqueId)?.contains(e.target)
        ) {
          hideOptions();
          window.removeEventListener("click", eventHandler, true);
        }
      },
      true,
    );

    window.addEventListener(
      "focus",
      function focusHandler(e) {
        const dropdownSelect = document.getElementById(uniqueId);
        if (
          dropdownSelect &&
          !document.getElementById(uniqueId)?.contains(e.target)
        ) {
          hideOptions();
          window.removeEventListener("focus", focusHandler, true);
        }
      },
      true,
    );

    window.addEventListener("keydown", onKeyPress);

    previousKeyDown = document.onkeydown;
    document.onkeydown = (event) => {
      if (event.key === "Escape") {
        hideOptions();
      }
    };
  } else {
    searchInputValue = "";
    window.removeEventListener("keydown", onKeyPress);
  }

  const onKeyPress = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      moveToNextOption();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      moveToPreviousOption();
    }
  };

  const moveToNextOption = () => {
    if (!optionButtons.length) return;
    const currentFocusedButtonIndex = optionButtons.findIndex((bt) => {
      return document.activeElement && document.activeElement === bt;
    });
    if (currentFocusedButtonIndex >= 0) {
      if (currentFocusedButtonIndex + 1 < optionButtons.length) {
        optionButtons[currentFocusedButtonIndex + 1]?.focus();
      }
    } else {
      optionButtons[0]?.focus();
    }
  };

  const moveToPreviousOption = () => {
    if (!optionButtons.length) return;
    const currentFocusedButtonIndex = optionButtons.findIndex((bt) => {
      return document.activeElement && document.activeElement === bt;
    });
    if (currentFocusedButtonIndex > 0) {
      if (currentFocusedButtonIndex < optionButtons.length) {
        optionButtons[currentFocusedButtonIndex - 1]?.focus();
      }
    } else if (currentFocusedButtonIndex !== 0) {
      optionButtons[optionButtons.length - 1]?.focus();
    }
  };

  const calculateOptionsPosition = () => {
    const inputRect = displayBoxEle?.getBoundingClientRect();
    return inputRect.top + inputRect.bottom > window.innerHeight
      ? "top"
      : "bottom";
  };

  const selectItem = (item) => {
    // searchInputValue = "";
    if (isMulti) {
      item.selected = item.hasOwnProperty("selected") ? !item.selected : true;
      operationOptions = operationOptions.map((itm) => {
        if (itm.id == item.id) return item;
        return itm;
      });
      // focusSearch();
    } else {
      operationOptions.forEach((op) => {
        if (op == item) item.selected = true;
        else op.selected = false;
      });
      toggleOptions();
    }

    refreshValues();
  };

  const focusSearch = () => {
    const inputEle = document.getElementById(`${uniqueId}MultiInput`);
    if (inputEle) inputEle.focus();
  };

  const unselectItem = (item) => {
    item.selected = false;
    if (!isMulti) {
      operationOptions.forEach((a) => (a.selected = false));
    }
    refreshValues();
  };

  const inSearchResults = (item, inputValue) => {
    if (!inputValue) return true;
    return item.name?.toUpperCase().includes(inputValue.toUpperCase());
  };

  const dispatchUse = () => dispatch("use");
</script>

<div
  class="flex-1 relative w-full"
  id={uniqueId}
  on:blur={hideOptions}
  use:dispatchUse
>
  <!-- on:blur|preventDefault={closeOptions} -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    class="{displayBoxClass} {isMulti ? 'multi-display-box' : ''}"
    role="button"
    on:click|preventDefault={onInputBoxFocus}
    bind:this={displayBoxEle}
  >
    {#each selectedItems as optionItem}
      <div
        class="flex flex-row items-center px-2 mb-[2px] bg-[#F1F1F2] gap-x-[4px] rounded-[6px] {isMulti
          ? 'hidden'
          : 'max-w-full'}"
        on:click|preventDefault={(e) => e.stopPropagation()}
      >
        {#if optionItem.showTooltip}
          <span class="tooltipbox">{optionItem.name}</span>
        {/if}
        <!-- svelte-ignore a11y-mouse-events-have-key-events -->
        <div
          class="truncate text-left flex-1"
          on:mouseover={() => (optionItem.showTooltip = true)}
          on:mouseout={() => (optionItem.showTooltip = false)}
          on:click|preventDefault={(e) => {
            e.stopPropagation();
            toggleOptions();
          }}
          style={showColoredOptions
            ? "color: " + optionItem[colorKey] + ";"
            : ""}
        >
          {optionItem.name}
        </div>
        <button
          class="dui-btn dui-btn-xs dui-btn-ghost w-[15px] rounded-full p-0 m-0 border-none"
          {disabled}
          on:click|preventDefault={(e) => {
            e.stopPropagation();
            unselectItem(optionItem);
          }}
        >
          <i class="fa fa-times w-[12px] h-[12px]" aria-hidden="true"></i>
        </button>
      </div>
    {/each}

    <input
      class="ml-[6px] bg-transparent text-[14px] flex-1 min-h-[16px] clipText leading-none {displayTextClass}"
      {disabled}
      type="text"
      placeholder={displayPlaceholder}
      bind:value={searchInputValue}
      on:focus={onInputBoxFocus}
      on:click={onInputBoxFocus}
      id={uniqueId + "MultiInput"}
      autocomplete="off"
      aria-autocomplete="none"
    />
  </div>
  <div
    class="optionsBox flex flex-col gap-y-[6px] py-[6px] rounded-lg border overflow-y-auto {optionsPosition} {smallOptionsBox
      ? 'max-h-[260px]'
      : 'max-h-[380px]'}"
    style={showOptions ? "display:flex;" : "display: none;"}
  >
    <!-- {#if enableAddOptions}
      <div
        class="flex flex-1 flex-row gap-x-[6px] h-[28px] my-[6px]"
      >
        <input
          type="text"
          class="dui-input dui-input-md flex-1"
          bind:value={addOptionInputValue}
          placeholder={_l("add_options")}
          {disabled}
        />
        <button
          class="dui-btn dui-btn-md dui-btn-circle dui-btn-ghost flex rounded-full p-0"
          disabled={disabled || !addOptionInputValue}
          on:click|preventDefault={addOption}
        >
          <AddIcon />
        </button>
      </div>
    {/if} -->
    {#if filteredUnselectedOptions.length}
      {#each filteredUnselectedOptions as optionItem, i (i)}
        <!-- <button
          class="dui-btn dui-btn-ghost option-item-button"
          on:click|preventDefault={selectItem(optionItem)}
          bind:this={optionButtons[i]}
        >
          <span
            class="flex-1 truncate text-left"
            style={showColoredOptions
              ? "color: " + optionItem[colorKey] + ";"
              : ""}
          >
            {optionItem.name}
          </span>
        </button> -->
        <div class="flex items-center gap-2 min-h-[42px] h-auto mr-2">
          <input
            type="checkbox"
            id={`${optionItem.id}Option`}
            class={`${defaultCheckboxClass}`}
            on:click={selectItem(optionItem)}
            bind:this={optionButtons[i]}
            checked={optionItem.selected}
          />
          <label
            class="whitespace-nowrap cursor-pointer w-full pt-1"
            for={`${optionItem.id}Option`}
            style={showColoredOptions
              ? "color: " + optionItem[colorKey] + ";"
              : ""}
          >
            {optionItem.name}
          </label>
        </div>
      {/each}
    {:else}
      <div
        class="flex flex-1 w-full text-[14px] font-semibold opacity-50 cursor-default"
      >
        No Options
      </div>
    {/if}

    {#if isMulti}
      <div class="flex flex-row flex-1 gap-x-[6px]">
        {#if operationOptions.length}
          <button
            class="dui-btn dui-btn-md border-none flex-1 dui-btn-glass out text-[14px]"
            on:click|preventDefault={selectAll}
            {disabled}
          >
            Select All
          </button>
        {/if}
        {#if selectedItems.length}
          <button
            class="dui-btn dui-btn-md border-none flex-1 dui-btn-glass text-[14px]"
            on:click|preventDefault={selectNone}
            {disabled}
          >
            Clear
          </button>
        {/if}
      </div>
    {/if}
  </div>
</div>

<style>
  .optionsBox {
    /* box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.05); */
    box-shadow: 3px 3px 8px 3px rgba(20, 46, 110, 0.1);
    position: absolute;
    width: 100%;
    z-index: 99999;
    background-color: #fff;
    padding: 10px;
  }

  .top {
    bottom: 100%;
  }

  .bottom {
    top: 100%;
  }

  .border-color {
    border-color: #818e9b;
  }

  .no-margin {
    margin: 0 !important;
  }

  .clipText {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    line-clamp: 1;
    line-height: normal;
    -webkit-box-orient: vertical;
  }

  input:not([type="checkbox"]) {
    outline: 0;
    border-width: 0;
    height: auto;
    font-size: 14px;
  }

  input::placeholder {
    opacity: 0.5;
  }

  .option-item-button {
    flex-direction: row;
    display: flex;
    justify-items: start;
    width: 100%;
    height: 24px;
    padding: 0 6px;
    margin: 3px 0;
    font-size: 14px;
    overflow: hidden;
    gap: 6px;
  }

  .multi-display-box {
    /* height: auto !important; */
    display: flex;
    flex-direction: row;
    gap: 3px;
    flex-wrap: wrap;
    overflow-y: visible;
  }

  .tooltipbox {
    /* box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.05); */
    box-shadow: 3px 3px 8px 3px rgba(20, 46, 110, 0.1);
    position: absolute;
    width: auto;
    z-index: 999999;
    padding: 4px 8px;
    bottom: 100%;
    display: block;
    background-color: #6f726c;
    color: white;
    border-radius: 6px;
    font-size: 13px;
    transition-duration: 200ms;
  }

  .options-item + .options-item {
    border-top: 1px dashed #a2c0d4;
  }
</style>
